export const image = {
    height: "150px",
    width: "150px",
    border: "1px solid black"
};

export const quantitySection = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "right"
};

export const quantityText = {
    width: "30px",
    textAlign: "center"
};

export const editRightSection = {
    textAlign: "right"
};

export const quanitityCol = {
    display: "flex",
    flex: "1",
    alignItems: "center"
};

export const depositText = {
    color: "red"
};

//MOBILE
export const mobile_body = {
    padding: "10px",
    display: "flex",
    flexDirection: "row"
};

export const mobile_textBox = {
    paddingLeft: "5px"
};

export const includedInDealText = {
    color: "red",
    fontWeight: "bold"
};
